<template>
    <div>
        <template v-if="label">
            <strong>{{label}}</strong><br>
        </template>
        <template v-if="value">
            {{ value }}
            <template v-if="appendText">
                {{ appendText }}
            </template>
        </template>
        <template v-else-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            -
        </template>
    </div>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        value() {
            return this.getSafely(this.getValue)
        }
    },
    props: {
        label: {type: String},
        getValue: {type: Function, required: true},
        appendText: {type: String}
    },
    mixins: [object]
}
</script>